export default {
	addCity: 'Добавить город',
	city: 'Город',
	country: 'Cтрана',
	countryRequired: 'Страну',
	options: 'Опции',
	edit: 'Изменить',
	editingCity: 'Редактирование города',
	areYouSureYouWantToDeleteCity: 'Вы уверены, что хотите удалить город?',
	cityCenterCoordinates: 'Координаты центра города',
	latitude: 'Широта',
	longitude: 'Долгота'
};
